import { render, staticRenderFns } from "./CategoryPathsViewer.vue?vue&type=template&id=d459ba8e&scoped=true&"
import script from "./CategoryPathsViewer.vue?vue&type=script&lang=ts&"
export * from "./CategoryPathsViewer.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryPathsViewer.vue?vue&type=style&index=0&id=d459ba8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d459ba8e",
  null
  
)

export default component.exports